



































































import Vue, { PropType } from 'vue';
import {
  CabinetConfigurationModel,
  CabinetReferenceConfigurationModel,
  CabinetReferenceConfigurationModelDefaults,
  CabinetReferenceType,
  EditMode,
  SearchReferenceConfigurationModel,
  SearchReferenceConfigurationModelDefaults,
  StoreReferenceConfigurationModel,
  StoreReferenceConfigurationModelDefaults,
  DocumentTypeConfigurationModel,
  ReferenceConfigurationModel,
  CabinetConfigurationLevel,
  CommonStoreReferenceConfigurationModelDefaults,
  NotificationModel
} from '@/types';
import MStoreAccordion from '@/components/shared/MStoreAccordion.vue';
import MStoreOrderableTable from '@/components/shared/Table/MStoreOrderableTable.vue';
import ReferenceConfiguration from '@/components/configuration/cabinet/ReferenceConfiguration.vue';
import MStoreDeleteConfirmationModal from '@/components/shared/MStoreDeleteConfirmationModal.vue';
import { CabinetConfigurationHelper, ModalHelpers, ObjectHelper } from '@/mixins';
import { ObjectUtils } from '@/utils/objectUtils';
import { mapActions, mapGetters } from 'vuex';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { BooleanUtils } from '@/utils/booleanUtils';

export default Vue.extend({
  name: 'ReferencesAccordion',
  mixins: [ObjectHelper, CabinetConfigurationHelper, ModalHelpers],
  data() {
    return {
      cabinetConfigurationClone: {} as CabinetConfigurationModel,
      documentTypeConfigurationClone: {} as DocumentTypeConfigurationModel,
      showReferenceConfiguration: false,
      referenceConfigurationEditMode: EditMode.Add,
      cabinetReferenceConfiguration: {} as CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: {} as StoreReferenceConfigurationModel,
      searchReferenceConfiguration: {} as SearchReferenceConfigurationModel,
      defaultStoreReferenceConfiguration: {} as StoreReferenceConfigurationModel
    };
  },
  props: {
    editMode: {
      type: Number as PropType<EditMode>,
      required: true
    },
    configurationLevel: {
      type: Number as PropType<CabinetConfigurationLevel>,
      required: true
    },
    cabinetConfiguration: {
      type: Object as () => CabinetConfigurationModel,
      required: true
    },
    referenceType: {
      type: Number as PropType<CabinetReferenceType>,
      required: true
    },
    documentTypeConfiguration: {
      type: Object as () => DocumentTypeConfigurationModel
    },
    isParentLoading: {
      type: Boolean,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      required: false
    },
    formName: {
      type: String,
      default: 'referenceConfigurationForm'
    },
    allowDelete: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    cloneCabinetConfiguration(this: any) {
      if (!this.isNullOrEmpty(this.cabinetConfiguration)) {
        this.cabinetConfigurationClone = ObjectUtils.deepCloneObject(this.cabinetConfiguration);
        this.setCabinetConfigurationDefaults();
      }
    },
    cloneDocumentTypeConfiguration(this: any) {
      if (!this.isNullOrEmpty(this.documentTypeConfiguration)) {
        this.documentTypeConfigurationClone = ObjectUtils.deepCloneObject(this.documentTypeConfiguration);
      }
    },
    cloneConfiguration(this: any) {
      this.cloneCabinetConfiguration();
      this.cloneDocumentTypeConfiguration();
    },
    setCabinetConfigurationDefaults(this: any) {
      if (this.isNullOrEmpty(this.cabinetConfigurationClone.cabinetReferences)) {
        this.cabinetConfigurationClone.cabinetReferences = [] as CabinetConfigurationModel[];
      }
      if (this.isNullOrEmpty(this.cabinetConfigurationClone.commonSearchReferencesConfiguration)) {
        this.cabinetConfigurationClone.commonSearchReferencesConfiguration = [] as SearchReferenceConfigurationModel[];
      }
      if (this.isNullOrEmpty(this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration)) {
        // tslint:disable-next-line:max-line-length
        this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration = [] as StoreReferenceConfigurationModel[];
      }
    },
    onAddButtonClicked(this: any) {
      this.referenceConfigurationEditMode = EditMode.Add;

      this.cabinetReferenceConfiguration = CabinetReferenceConfigurationModelDefaults;
      this.cabinetReferenceConfiguration.referenceType = this.referenceType;
      this.cabinetReferenceConfiguration.documentTypeId = this.documentTypeConfigurationClone.id === undefined ? null : this.documentTypeConfigurationClone.id;
      this.cabinetReferenceConfiguration.isNew = true;

      this.storeReferenceConfiguration = StoreReferenceConfigurationModelDefaults;
      this.storeReferenceConfiguration.referenceType = this.referenceType;
      if (this.isInCommonReferenceMode && this.isDocumentTypeConfigurationLevel) {
        this.storeReferenceConfiguration.useDefaults = true;
      }
      this.searchReferenceConfiguration = SearchReferenceConfigurationModelDefaults;
      this.searchReferenceConfiguration.referenceType = this.referenceType;
      this.showReferenceConfiguration = true;
    },
    onEditButtonClicked(this: any, row: any) {
      this.referenceConfigurationEditMode = EditMode.Edit;
      this.getReferenceFromSelectedRow(row);
      this.showReferenceConfiguration = true;
    },
    onViewButtonClicked(this: any, row: any) {
      this.referenceConfigurationEditMode = EditMode.View;
      this.getReferenceFromSelectedRow(row);
      this.showReferenceConfiguration = true;
    },
    getCabinetReferenceConfiguration(this: any, referenceNumber: number, referenceDescription: string) {
      if (this.isDocumentTypeConfigurationLevel && this.isInDocumentReferenceMode) {
        return this.cabinetConfigurationClone.cabinetReferences.find(
          (reference: any) =>
            reference.referenceType === this.referenceType &&
            reference.referenceNumber === referenceNumber &&
            reference.description === referenceDescription &&
            reference.documentTypeId === this.documentTypeConfigurationClone.id
        );
      }

      return this.cabinetConfigurationClone.cabinetReferences.find(
        (reference: any) => reference.referenceType === this.referenceType && reference.referenceNumber === referenceNumber && reference.description === referenceDescription
      );
    },
    getSearchReferenceConfiguration(this: any, referenceNumber: number) {
      if (this.isInCommonReferenceMode) {
        return this.cabinetConfigurationClone.commonSearchReferencesConfiguration.find((reference: any) => reference.referenceNumber === referenceNumber);
      }

      if (this.isInDocumentReferenceMode) {
        const documentReferenceConfiguration = this.documentTypeReferenceConfigurations.find(
          (reference: ReferenceConfigurationModel) => reference.referenceNumber === referenceNumber && reference.referenceType === this.referenceType
        );
        return documentReferenceConfiguration.searchReferenceConfiguration;
      }
    },
    getStoreReferenceConfiguration(this: any, referenceNumber: number) {
      if (this.isInCommonReferenceMode) {
        let storeReferenceConfiguration;
        if (this.isCabinetConfigurationLevel) {
          // tslint:disable-next-line:max-line-length
          storeReferenceConfiguration = this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.find((reference: any) => reference.referenceNumber === referenceNumber);
        }
        if (this.isDocumentTypeConfigurationLevel) {
          const referenceConfiguration = this.documentTypeReferenceConfigurations.find(
            (reference: any) => reference.referenceNumber === referenceNumber && reference.referenceType === this.referenceType
          );
          if (!ObjectUtils.isNullOrEmpty(referenceConfiguration)) {
            storeReferenceConfiguration = referenceConfiguration.storeReferenceConfiguration;
          }
        }

        if (ObjectUtils.isNullOrEmpty(storeReferenceConfiguration)) {
          storeReferenceConfiguration = CommonStoreReferenceConfigurationModelDefaults;
          storeReferenceConfiguration.referenceNumber = referenceNumber;
        }
        return storeReferenceConfiguration;
      }

      if (this.isInDocumentReferenceMode) {
        const documentReferenceConfiguration = this.documentTypeReferenceConfigurations.find(
          (reference: ReferenceConfigurationModel) => reference.referenceNumber === referenceNumber && reference.referenceType === this.referenceType
        );

        return documentReferenceConfiguration.storeReferenceConfiguration;
      }
    },
    getDefaultStoreReferenceConfiguration(this: any, referenceNumber: number) {
      if (this.isInCommonReferenceMode && this.isDocumentTypeConfigurationLevel) {
        // tslint:disable-next-line:max-line-length
        let defaultStoreReferenceConfiguration = this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.find((reference: any) => reference.referenceNumber === referenceNumber);

        if (ObjectUtils.isNullOrEmpty(defaultStoreReferenceConfiguration)) {
          defaultStoreReferenceConfiguration = CommonStoreReferenceConfigurationModelDefaults;
          defaultStoreReferenceConfiguration.referenceNumber = referenceNumber;
        }
        return defaultStoreReferenceConfiguration;
      }
    },
    getReferenceFromSelectedRow(this: any, row: { item: CabinetReferenceConfigurationModel }) {
      const referenceNumber = row.item.referenceNumber;
      const description = row.item.description;

      this.cabinetReferenceConfiguration = this.getCabinetReferenceConfiguration(referenceNumber, description);
      this.searchReferenceConfiguration = this.getSearchReferenceConfiguration(referenceNumber);
      this.storeReferenceConfiguration = this.getStoreReferenceConfiguration(referenceNumber);
      this.defaultStoreReferenceConfiguration = this.getDefaultStoreReferenceConfiguration(referenceNumber);
    },
    async deleteCabinetReferenceAndReOrder(this: any, referenceNumber: number) {
      let cabinetReferenceToDeleteIndex;
      if (this.isInCommonReferenceMode) {
        cabinetReferenceToDeleteIndex = this.cabinetConfigurationClone.cabinetReferences.findIndex(
          (reference: any) => reference.referenceType === CabinetReferenceType.Common && reference.referenceNumber === referenceNumber
        );
      } else if (this.isInDocumentReferenceMode) {
        const documentTypeId = Number(this.$route.params.documentTypeId);
        cabinetReferenceToDeleteIndex = this.cabinetConfigurationClone.cabinetReferences.findIndex(
          (reference: any) =>
            reference.referenceType === CabinetReferenceType.Document &&
            reference.referenceNumber === referenceNumber &&
            (reference.documentTypeId === documentTypeId || (!documentTypeId && reference.isNew))
        );
      }

      const cabinetReferenceToDelete: CabinetReferenceConfigurationModel = this.cabinetConfigurationClone.cabinetReferences[cabinetReferenceToDeleteIndex];
      if (cabinetReferenceToDelete.id !== null) {
        if (!cabinetReferenceToDelete.canDelete) {
          return;
        }
        this.cabinetConfigurationClone.cabinetReferences[cabinetReferenceToDeleteIndex].isDeleted = true;
      } else {
        if (this.isInCommonReferenceMode) {
          (this.cabinetConfigurationClone.cabinetReferences as CabinetReferenceConfigurationModel[])
            .filter((cabinetReference) => !cabinetReference.isDeleted && cabinetReference.referenceType === cabinetReferenceToDelete.referenceType)
            .forEach((x) => {
              this.decrementDisplayOrder(x, cabinetReferenceToDelete);
              if (cabinetReferenceToDelete.isNew === true) {
                this.decrementReferenceNumber(x, cabinetReferenceToDelete);
                this.decrementFieldNumber(x, cabinetReferenceToDelete);
              }
            });
        } else if (this.isInDocumentReferenceMode) {
          (this.cabinetConfigurationClone.cabinetReferences as CabinetReferenceConfigurationModel[])
            .filter(
              (cabinetReference) =>
                !cabinetReference.isDeleted &&
                cabinetReference.referenceType === cabinetReferenceToDelete.referenceType &&
                cabinetReference.documentTypeId === cabinetReferenceToDelete.documentTypeId
            )
            .forEach((x) => {
              this.decrementDisplayOrder(x, cabinetReferenceToDelete);
              if (cabinetReferenceToDelete.isNew === true) {
                this.decrementReferenceNumber(x, cabinetReferenceToDelete);
                this.decrementFieldNumber(x, cabinetReferenceToDelete);
              }
            });
        }

        this.cabinetConfigurationClone.cabinetReferences.splice(cabinetReferenceToDeleteIndex, 1);
      }
      if (!this.isApplicationDirty) {
        this.setApplicationDirty(true);
      }
    },
    decrementDisplayOrder(x: CabinetReferenceConfigurationModel, cabinetReferenceToDelete: CabinetReferenceConfigurationModel) {
      if (x.displayOrder && cabinetReferenceToDelete.displayOrder && x.displayOrder > cabinetReferenceToDelete.displayOrder) {
        x.displayOrder = x.displayOrder - 1;
      }
    },
    decrementReferenceNumber(x: CabinetReferenceConfigurationModel, cabinetReferenceToDelete: CabinetReferenceConfigurationModel) {
      if (x.referenceNumber && cabinetReferenceToDelete.referenceNumber && x.referenceNumber > cabinetReferenceToDelete.referenceNumber && x.isNew === true) {
        if (this.isInCommonReferenceMode) {
          this.decrementStoreAndSearchReferencesReferenceNumber(x.referenceNumber);
        }
        x.referenceNumber = x.referenceNumber - 1;
      }
    },
    decrementFieldNumber(x: CabinetReferenceConfigurationModel, cabinetReferenceToDelete: CabinetReferenceConfigurationModel) {
      if (x.fieldNumber && cabinetReferenceToDelete.fieldNumber && x.fieldNumber > cabinetReferenceToDelete.fieldNumber && x.isNew === true) {
        x.fieldNumber = x.fieldNumber - 1;
      }
    },
    decrementStoreAndSearchReferencesReferenceNumber(referenceNumber: number) {
      this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.forEach((x: any) => {
        if (x.referenceNumber === referenceNumber) {
          x.referenceNumber--;
        }
      });
      this.cabinetConfigurationClone.commonSearchReferencesConfiguration.forEach((x: any) => {
        if (x.referenceNumber === referenceNumber) {
          x.referenceNumber--;
        }
      });
    },
    deleteDefaultCommonStoreReferencesConfigurationAndReOrder(this: any, referenceNumber: number) {
      // tslint:disable-next-line:max-line-length
      this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration = this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.filter(
        (reference: any) => reference.referenceNumber !== referenceNumber
      );
    },
    deleteCommonSearchReferencesConfigurationAndReOrder(this: any, referenceNumber: number) {
      // tslint:disable-next-line:max-line-length
      this.cabinetConfigurationClone.commonSearchReferencesConfiguration = this.cabinetConfigurationClone.commonSearchReferencesConfiguration.filter(
        (reference: any) => reference.referenceNumber !== referenceNumber
      );
    },
    deleteCommonReferenceFromDocumentTypeAndReOrder(this: any, referenceNumber: number) {
      if (!Array.isArray(this.cabinetConfigurationClone.documentTypes)) {
        return;
      }
      this.cabinetConfigurationClone.documentTypes.forEach((dt: DocumentTypeConfigurationModel) => {
        const documentTypeIndex = this.cabinetConfigurationClone.documentTypes.findIndex((documentType: DocumentTypeConfigurationModel) => documentType.id === dt.id);
        const documentTypeReferenceToDeleteIndex = this.findReferenceConfigurationIndexForDocumentType(
          this.cabinetConfigurationClone,
          documentTypeIndex,
          CabinetReferenceType.Common,
          referenceNumber
        );
        this.cabinetConfigurationClone.documentTypes[documentTypeIndex].referencesConfiguration.splice(documentTypeReferenceToDeleteIndex, 1);
      });
    },
    deleteReferenceFromDocumentTypeAndReOrder(this: any, referenceNumber: number) {
      const documentTypeIndex = this.cabinetConfigurationClone.documentTypes.findIndex((documentType: DocumentTypeConfigurationModel) => documentType.id === this.documentTypeConfigurationClone.id);
      if (documentTypeIndex !== -1) {
        const documentTypeReferenceToDeleteIndex = this.findReferenceConfigurationIndexForDocumentType(
          this.cabinetConfigurationClone,
          documentTypeIndex,
          CabinetReferenceType.Document,
          referenceNumber
        );

        this.cabinetConfigurationClone.documentTypes[documentTypeIndex].referencesConfiguration.splice(documentTypeReferenceToDeleteIndex, 1);
      }

      const documentTypeReferenceToDeleteFromDocTypeIndex = this.documentTypeReferenceConfigurations.findIndex(
        (configModel: ReferenceConfigurationModel) => configModel.referenceType === CabinetReferenceType.Document && configModel.referenceNumber === referenceNumber
      );
      this.documentTypeReferenceConfigurations.splice(documentTypeReferenceToDeleteFromDocTypeIndex, 1);
    },
    async onDeleteConfirmation(this: any, referenceNumber: number, isNew: boolean) {
      if (isNew && !(await this.showConfirmationModalAsync(this.$bvModal, 'This reference has not yet been saved. Are you sure you want to delete?'))) {
        return;
      }

      if (this.isInCommonReferenceMode) {
        this.deleteDefaultCommonStoreReferencesConfigurationAndReOrder(referenceNumber);
        this.deleteCommonSearchReferencesConfigurationAndReOrder(referenceNumber);
        this.deleteCommonReferenceFromDocumentTypeAndReOrder(referenceNumber);
      }
      if (this.isInDocumentReferenceMode) {
        this.deleteReferenceFromDocumentTypeAndReOrder(referenceNumber);
      }

      await this.deleteCabinetReferenceAndReOrder(referenceNumber);
      this.$emit('on-references-changed', this.cabinetConfigurationClone, this.documentTypeConfigurationClone);
    },
    setReferenceFieldAndOrderNumber(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel
    ) {
      // tslint:disable-next-line:max-line-length
      const selectedCabinetReference: CabinetReferenceConfigurationModel[] = this.cabinetConfigurationClone.cabinetReferences.filter((cabinetReference: CabinetReferenceConfigurationModel) =>
        this.isInCommonReferenceMode
          ? cabinetReference.referenceType === CabinetReferenceType.Common
          : cabinetReference.referenceType === CabinetReferenceType.Document &&
            !(cabinetReference.documentTypeId === null && cabinetReference.id !== null) &&
            cabinetReference.documentTypeId === this.documentTypeConfigurationClone.id
      );

      const referenceNumber = this.getMaxId(selectedCabinetReference, 'referenceNumber') + 1;
      cabinetReferenceConfiguration.referenceNumber = referenceNumber;
      storeReferenceConfiguration.referenceNumber = referenceNumber;
      searchReferenceConfiguration.referenceNumber = referenceNumber;

      const fieldNumber = this.getMaxId(selectedCabinetReference, 'fieldNumber') + 1;
      cabinetReferenceConfiguration.fieldNumber = fieldNumber;

      const displayOrder =
        this.getMaxId(
          selectedCabinetReference.filter((x) => !x.isDeleted),
          'displayOrder'
        ) + 1;
      cabinetReferenceConfiguration.displayOrder = displayOrder;
    },
    addReference(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel
    ) {
      this.setReferenceFieldAndOrderNumber(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration);

      this.cabinetConfigurationClone.cabinetReferences.push(cabinetReferenceConfiguration);

      if (this.isInCommonReferenceMode) {
        this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.push(storeReferenceConfiguration);
        this.cabinetConfigurationClone.commonSearchReferencesConfiguration.push(searchReferenceConfiguration);
        if (Array.isArray(this.cabinetConfigurationClone.documentTypes)) {
          this.cabinetConfigurationClone.documentTypes.forEach((dt: DocumentTypeConfigurationModel) => {
            if (
              !dt.referencesConfiguration.some(
                (rc: ReferenceConfigurationModel) => rc.referenceType === cabinetReferenceConfiguration.referenceType && rc.referenceNumber === cabinetReferenceConfiguration.referenceNumber
              )
            ) {
              dt.referencesConfiguration.push({
                referenceType: cabinetReferenceConfiguration.referenceType,
                referenceNumber: cabinetReferenceConfiguration.referenceNumber,
                storeReferenceConfiguration: { ...storeReferenceConfiguration, ...{ useDefaults: true } },
                searchReferenceConfiguration
              } as ReferenceConfigurationModel);
            }
          });
        }
      }
      if (this.isInDocumentReferenceMode) {
        if (
          !this.documentTypeReferenceConfigurations.some(
            (rc: ReferenceConfigurationModel) => rc.referenceType === cabinetReferenceConfiguration.referenceType && rc.referenceNumber === cabinetReferenceConfiguration.referenceNumber
          )
        ) {
          this.documentTypeReferenceConfigurations.push({
            referenceType: cabinetReferenceConfiguration.referenceType,
            referenceNumber: cabinetReferenceConfiguration.referenceNumber,
            storeReferenceConfiguration,
            searchReferenceConfiguration
          } as ReferenceConfigurationModel);
        }
      }
    },
    editReference(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel
    ) {
      if (this.isInCommonReferenceMode) {
        this.editCommonReference(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration);
      }
      if (this.isInDocumentReferenceMode) {
        this.editDocumentReference(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration);
      }
    },
    editReferenceForDocumentType(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel,
      documentTypeId: number | null
    ) {
      if (!this.isNewDocumentType) {
        const documentTypeConfigurationIndex = this.cabinetConfigurationClone.documentTypes.findIndex((docType: DocumentTypeConfigurationModel) => docType.id === documentTypeId);

        const documentTypeReferenceConfigurationIndex = this.findReferenceConfigurationIndexForDocumentType(
          this.cabinetConfigurationClone,
          documentTypeConfigurationIndex,
          cabinetReferenceConfiguration.referenceType,
          cabinetReferenceConfiguration.referenceNumber
        );

        this.cabinetConfigurationClone.documentTypes[documentTypeConfigurationIndex].referencesConfiguration[documentTypeReferenceConfigurationIndex] = {
          referenceType: cabinetReferenceConfiguration.referenceType,
          referenceNumber: cabinetReferenceConfiguration.referenceNumber,
          storeReferenceConfiguration,
          searchReferenceConfiguration
        } as ReferenceConfigurationModel;
      }

      const docTypeReferenceIndex = this.documentTypeReferenceConfigurations.findIndex(
        (refConfig: ReferenceConfigurationModel) =>
          refConfig.referenceType === cabinetReferenceConfiguration.referenceType && refConfig.referenceNumber === cabinetReferenceConfiguration.referenceNumber
      );
      this.documentTypeReferenceConfigurations[docTypeReferenceIndex] = {
        referenceType: cabinetReferenceConfiguration.referenceType,
        referenceNumber: cabinetReferenceConfiguration.referenceNumber,
        storeReferenceConfiguration,
        searchReferenceConfiguration
      } as ReferenceConfigurationModel;
    },
    editCommonReference(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel
    ) {
      const cabinetReferenceIndex = this.cabinetConfigurationClone.cabinetReferences.findIndex(
        (cabinetReference: CabinetReferenceConfigurationModel) =>
          cabinetReference.referenceType === cabinetReferenceConfiguration.referenceType && cabinetReference.referenceNumber === cabinetReferenceConfiguration.referenceNumber
      );
      if (this.isCabinetConfigurationLevel) {
        this.cabinetConfigurationClone.cabinetReferences[cabinetReferenceIndex] = cabinetReferenceConfiguration;

        // tslint:disable-next-line:max-line-length
        const storeReferenceIndex = this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.findIndex(
          (storeReference: StoreReferenceConfigurationModel) => storeReference.referenceNumber === storeReferenceConfiguration.referenceNumber
        );

        if (storeReferenceIndex === -1) {
          this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration.push(storeReferenceConfiguration);
        } else {
          this.cabinetConfigurationClone.defaultCommonStoreReferencesConfiguration[storeReferenceIndex] = storeReferenceConfiguration;
        }

        const searchReferenceIndex = this.cabinetConfigurationClone.commonSearchReferencesConfiguration.findIndex(
          (searchReference: SearchReferenceConfigurationModel) => searchReference.referenceNumber === searchReferenceConfiguration.referenceNumber
        );
        this.cabinetConfigurationClone.commonSearchReferencesConfiguration[searchReferenceIndex] = searchReferenceConfiguration;
      }
      if (this.isDocumentTypeConfigurationLevel) {
        this.cabinetConfigurationClone.cabinetReferences[cabinetReferenceIndex] = cabinetReferenceConfiguration;
        this.editReferenceForDocumentType(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration, this.documentTypeConfigurationClone.id);
      }
    },
    editDocumentReference(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel
    ) {
      const cabinetReferenceIndex = this.getCabinetReferenceIndex(this.cabinetConfigurationClone, this.cabinetReferenceConfiguration, this.documentTypeConfigurationClone.id);
      this.cabinetConfigurationClone.cabinetReferences[cabinetReferenceIndex] = cabinetReferenceConfiguration;

      this.editReferenceForDocumentType(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration, cabinetReferenceConfiguration.documentTypeId);
    },
    onOkReferenceConfiguration(
      this: any,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      storeReferenceConfiguration: StoreReferenceConfigurationModel,
      searchReferenceConfiguration: SearchReferenceConfigurationModel
    ) {
      if (this.isInReferenceViewMode) {
        return;
      }

      if (this.isInAddReferenceMode) {
        this.addReference(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration);
      }

      if (this.isInEditReferenceMode) {
        this.editReference(cabinetReferenceConfiguration, storeReferenceConfiguration, searchReferenceConfiguration);
      }

      this.$emit('on-references-changed', this.cabinetConfigurationClone, this.documentTypeConfigurationClone);
      this.showReferenceConfiguration = false;
    },
    onCancelReferenceConfiguration(this: any) {
      this.showReferenceConfiguration = false;
    },
    onOrderChanged(this: any, changeOrderEvent: any) {
      const reorderedItems = changeOrderEvent.reorderedItems;
      this.cabinetConfigurationClone.cabinetReferences = this.cabinetConfigurationClone.cabinetReferences.map(
        (reference: CabinetReferenceConfigurationModel) =>
          ({
            ...reference,
            displayOrder:
              reorderedItems.find(
                (reorderedReference: CabinetReferenceConfigurationModel) =>
                  reorderedReference.referenceType === reference.referenceType &&
                  reorderedReference.documentTypeId === reference.documentTypeId &&
                  reorderedReference.referenceNumber === reference.referenceNumber
              )?.displayOrder || reference.displayOrder
          } as CabinetReferenceConfigurationModel)
      );
      if (!this.isApplicationDirty) {
        this.setApplicationDirty(true);
      }
      this.$emit('on-references-changed', this.cabinetConfigurationClone, this.documentTypeConfigurationClone);
    }
  },
  computed: {
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty']),
    title(this: any) {
      return `${(this.isInCommonReferenceMode ? this.cabinetConfiguration.description : this.documentTypeConfiguration.description) ?? ''} References`.trim();
    },
    referencesCount(this: any) {
      return this.references?.length ?? 0;
    },
    accordionTitle(this: any) {
      return `${this.title} (${this.referencesCount})`;
    },
    references(this: any) {
      return (
        (this.cabinetConfigurationClone as CabinetConfigurationModel)?.cabinetReferences?.filter((cabinetReference: CabinetReferenceConfigurationModel) =>
          this.isInCommonReferenceMode
            ? cabinetReference.referenceType === CabinetReferenceType.Common && !cabinetReference.isDeleted
            : cabinetReference.referenceType === CabinetReferenceType.Document &&
              !(cabinetReference.documentTypeId === null && cabinetReference.id !== null) &&
              cabinetReference.documentTypeId === this.documentTypeConfigurationClone.id &&
              !cabinetReference.isDeleted
        ) || ([] as CabinetReferenceConfigurationModel[])
      );
    },
    documentTypeReferenceConfigurations(this: any) {
      return this.documentTypeConfigurationClone?.referencesConfiguration || ([] as ReferenceConfigurationModel[]);
    },
    isInViewMode(this: any) {
      return this.editMode === EditMode.View;
    },
    isInViewReferenceMode(this: any) {
      return this.referenceConfigurationEditMode === EditMode.View;
    },
    isInAddReferenceMode(this: any) {
      return this.referenceConfigurationEditMode === EditMode.Add;
    },
    isInEditReferenceMode(this: any) {
      return this.referenceConfigurationEditMode === EditMode.Edit;
    },
    canAddCommonReferences(this: any) {
      return !this.isParentLoading && !this.isInViewMode && (this.isInDocumentReferenceMode || (this.isCabinetConfigurationLevel && this.isInCommonReferenceMode));
    },
    isCabinetConfigurationLevel(this: any) {
      return this.configurationLevel === CabinetConfigurationLevel.Cabinet;
    },
    isDocumentTypeConfigurationLevel(this: any) {
      return this.configurationLevel === CabinetConfigurationLevel.DocumentType;
    },
    isNewDocumentType(this: any) {
      return !ObjectUtils.isNullOrEmpty(this.documentTypeConfiguration) && this.documentTypeConfiguration.isNew;
    },
    isInDocumentReferenceMode(this: any) {
      return this.referenceType === CabinetReferenceType.Document;
    },
    isInCommonReferenceMode(this: any) {
      return this.referenceType === CabinetReferenceType.Common;
    },
    referenceFields(this: any): [] {
      return this.FIELDS.filter((field: any) => this.cabinetConfiguration.isMultiValueReferencesFeatureEnabled || field.key !== 'isMultiValue');
    }
  },
  watch: {
    cabinetConfiguration: {
      handler(this: any) {
        this.cloneCabinetConfiguration();
      },
      deep: true
    },
    documentTypeConfiguration: {
      handler(this: any) {
        this.cloneDocumentTypeConfiguration();
      },
      deep: true
    }
  },
  mounted(this: any) {
    this.cloneConfiguration();
  },
  created(this: any) {
    this.FIELDS = [
      {
        key: 'id',
        label: 'Id',
        thClass: 'd-none',
        tdClass: 'd-none'
      },
      {
        key: 'description',
        label: 'Name'
      },
      {
        key: 'referenceNumber',
        label: 'Reference Number',
        thClass: 'w-15',
        tdClass: 'w-15'
      },
      {
        key: 'displayOrder',
        label: 'Order',
        thClass: 'w-15',
        tdClass: 'w-15'
      },
      {
        key: 'isMultiValue',
        label: 'Multi-value',
        thClass: 'w-15',
        tdClass: 'w-15',
        formatter: BooleanUtils.ConvertBooleanToYesNo
      },
      {
        key: 'actions',
        label: '',
        thClass: 'w-20',
        tdClass: 'w-20'
      }
    ];
  },
  components: {
    MStoreAccordion,
    MStoreOrderableTable,
    ReferenceConfiguration,
    MStoreDeleteConfirmationModal
  }
});
